/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
/* eslint-disable implicit-arrow-linebreak */
import styled, { css } from 'styled-components';

interface ContactProps {
  isPage?: boolean;
}

export const Container = styled.div`
  margin-top: 50px;

  .titleWrapper {
    height: 40px;
    width: 500px;
    margin-left: 17%;
    @media (max-width: 768px) {
      margin-left: 0%;
      width: 100%;
    }
  }
  .titleWrapperAccess {
    height: 40px;
    width: 500px;
    margin-left: 17%;
    @media (max-width: 768px) {
      margin-left: 0%;
      width: 100%;
    }
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
      justify-content:center;
    }
  }
  .TitleContainerAccess {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    @media (max-width: 768px) {
      justify-content:center;
    }
  }

  .suporte {
    @media (max-width: 767px) {
      margin-top: 50px;
    }
    @media (max-width: 368px) {
      margin-top: 100px;
    }
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--purple);

  align-items: center;
  justify-content: space-between;
`;

export const Content = styled.div`
  width: 100%;
  padding-bottom: 25px;
  padding-top: 25px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  div {
    margin-bottom: 10px;
  }
`;

export const ModalRemoteAcess = styled.div`
  height: 300px;
  width: 500px;
  padding: 0px 10px 20px 10px;
  text-align: center;
  h2 {
    font-weight: 14px;
  }
  p {
    font-weight: 12px;
    padding-bottom: 10px;
  }
  .TextoAcesso {
    height: auto;
    width: auto;
  }
  .remotes {
    width: 500px;
    @media (max-width: 900px) {
      width: 400px;

    }
    @media (max-width: 500px) {
      width: 300px;

    }
    @media (max-width: 770px) {
      padding: 80px 10px 20px 10px;
      
    }
  }
  .remote {
    width: 500px;
    @media (max-width: 900px) {
      width: 400px;

    }
    @media (max-width: 500px) {
      width: 300px;

    }
    @media (max-width: 770px) {
      padding: 50px 10px 20px 10px;
      
    }
  }
`;

export const Main = styled.div<ContactProps>`
  width: 100%;
  margin-left: 5px;

    ${(props) =>
    // eslint-disable-next-line prettier/prettier
    props.isPage &&
    css`
        margin-top: 3rem;
        margin-bottom: 1.5rem;
        align-items: flex-start;
      `}

    @media (max-width: 768px) {
      flex-wrap: wrap;
      margin-bottom: 9rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-top: 30px;
    }
  }

  svg {
    color: #424b5a;
  }
`;

export const GridContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1rem;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    margin-top: 2rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

export const FlexContainer = styled.div<ContactProps>`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  margin-right: 2rem;
  margin-bottom: 8rem;
  text-align: left;
  align-self: flex-start;

  @media (max-width: 768px) {
    margin-right: 0rem;
  }

  .section-contact {
    display: grid;
    @media (max-width: 767px) {
      align-items: center;
      align-self: center;
      margin-top: -90px;
    }
  }

  .text {
    margin-left: 15px;
    font-size: 1rem;
  }

  p {
    margin-top: 10px;
    margin-bottom: 1rem;
    font-size: 1rem;
  }

  .bairro {
    margin-left: 35px;
    font-size: 1rem;
  }

  h2 {
    align-self: flex-start;
    color: #505D68;;
    font-size: 2.1rem;
    margin-bottom: auto;

    @media (max-width: 767px) {
      width: 100%;
      text-align: center;
    }

    ${(props) =>
    // eslint-disable-next-line prettier/prettier
    props.isPage &&
    css`
        color: var(--title-higlight);
      `}
  }

  span {
    margin-top: 1rem;
    font-size: 1.1rem;
  }

  .button {
    margin-top: 2rem;
    font-size: 15px;
    width: 100%;

    @media (max-width: 480px) {
      margin-top: 1rem;
      width: 100%;
    }

    ${(props) =>
    // eslint-disable-next-line prettier/prettier
    props.isPage &&
    css`
        width: 100%;
        border-radius: 6px;
      `}
  }

  .medias {
    margin-top: 1px;
    width: 38%;
    margin-left: 0px;
    display: flex;
    justify-content: space-between;

    @media (max-width: 768px) {
      width: 150px;
      margin: 24px auto;
      justify-content: center;
    }

    img {
      height: 21px;
      padding-right: 3rem;
    }
    @media (max-width: 317px) {
      margin-top: 1rem;
      width: 80%;
      justify-content: center;
      margin-left: 2rem;
    }
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-right: 2rem;
  flex-direction: column;

  input {
    height: 35px;
  }

  .input-mensagem {
    height: 100px;
  }
  .inputremote {
    height: 100px;
  }

  .input-mensagem::placeholder {
    position: relative;
  }

  @media (max-width: 768px) {
    margin-top: -80px;
    margin-bottom: 320px;
    margin-right: 0;
  }

  @media (max-width: 480px) {
    width: 100%;
  }

`;

export const FormWrappeEspecial = styled.div`
  display: flex;
  width: 500px;
  margin-right: 2rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  input {
    height: 35px;
  }

  .input-mensagem {
    height: 100px;
  }
  .inputremote {
    height: 100px;
  }

  .input-mensagem::placeholder {
    position: relative;
  }

  @media (max-width: 768px) {
    margin-top: -80px;
    margin-bottom: 320px;
    margin-right: 0;
  }

  @media (max-width: 480px) {
    width: 100%;
  }

`;
